"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENSITIVE_COUNTRIES = exports.BenchmarkingVariables = exports.FinancialDocumentTaskStates = exports.PeriodType = exports.CompanyEquityRaised = exports.CompanyTargetDebtRaise = exports.CompanyExistingDebt = exports.CompanyOnboardingAccountType = exports.CompanyHeadcount = exports.CompanyYearOverYearGrowthRate = exports.CompanyBusinessType = exports.CompanySegment = exports.CompanyType = void 0;
var CompanyType;
(function (CompanyType) {
    CompanyType["Admin"] = "admin";
    CompanyType["Investor"] = "investor";
    CompanyType["SyndicationInvestor"] = "syndication_investor";
    CompanyType["Company"] = "company";
    CompanyType["BalanceSheetPartner"] = "balance_sheet_partner";
    CompanyType["Fund"] = "fund";
})(CompanyType = exports.CompanyType || (exports.CompanyType = {}));
var CompanySegment;
(function (CompanySegment) {
    CompanySegment["Mice"] = "mice";
    CompanySegment["Boar"] = "boar";
    CompanySegment["Whale"] = "whale";
})(CompanySegment = exports.CompanySegment || (exports.CompanySegment = {}));
var CompanyBusinessType;
(function (CompanyBusinessType) {
    CompanyBusinessType["ConsumerProducts"] = "consumer_products";
    CompanyBusinessType["ConsumerFinance"] = "consumer_finance";
    CompanyBusinessType["App"] = "app";
    CompanyBusinessType["Retail"] = "retail";
    CompanyBusinessType["Services"] = "services";
    CompanyBusinessType["SaasPositiveChurn"] = "saas_positive_churn";
    CompanyBusinessType["SaasNegativeChurn"] = "saas_negative_churn";
    CompanyBusinessType["CommercialFinance"] = "commercial_finance";
    CompanyBusinessType["Subscriptions"] = "subscriptions";
    CompanyBusinessType["Other"] = "other";
    CompanyBusinessType["Manufacturer"] = "manufacturer";
    CompanyBusinessType["Media"] = "media";
    CompanyBusinessType["Marketplace"] = "marketplace";
    CompanyBusinessType["Gaming"] = "gaming";
    CompanyBusinessType["ECommerce"] = "e_commerce";
    CompanyBusinessType["Health"] = "health";
    CompanyBusinessType["HealthIT"] = "health_it";
})(CompanyBusinessType = exports.CompanyBusinessType || (exports.CompanyBusinessType = {}));
var CompanyYearOverYearGrowthRate;
(function (CompanyYearOverYearGrowthRate) {
    CompanyYearOverYearGrowthRate["LessThan0Percentage"] = "less_than_0_percentage";
    CompanyYearOverYearGrowthRate["Between0And25Percentage"] = "between_0_and_25_percentage";
    CompanyYearOverYearGrowthRate["Between25And50Percentage"] = "between_25_and_50_percentage";
    CompanyYearOverYearGrowthRate["Between50And100Percentage"] = "between_50_and_100_percentage";
    CompanyYearOverYearGrowthRate["Between100And200Percentage"] = "between_100_and_200_percentage";
    CompanyYearOverYearGrowthRate["Between200And300Percentage"] = "between_200_and_300_percentage";
    CompanyYearOverYearGrowthRate["Between300And400Percentage"] = "between_300_and_400_percentage";
    CompanyYearOverYearGrowthRate["Between400And500Percentage"] = "between_400_and_500_percentage";
    CompanyYearOverYearGrowthRate["MoreThan500Percentage"] = "more_than_500_percentage";
})(CompanyYearOverYearGrowthRate = exports.CompanyYearOverYearGrowthRate || (exports.CompanyYearOverYearGrowthRate = {}));
var CompanyHeadcount;
(function (CompanyHeadcount) {
    CompanyHeadcount["Between0and10"] = "between_0_and_10";
    CompanyHeadcount["Between10and50"] = "between_10_and_50";
    CompanyHeadcount["Between50and100"] = "between_50_and_100";
    CompanyHeadcount["Between100and250"] = "between_100_and_250";
    CompanyHeadcount["Between250and500"] = "between_250_and_500";
    CompanyHeadcount["MoreThan500"] = "between_500_and_more";
})(CompanyHeadcount = exports.CompanyHeadcount || (exports.CompanyHeadcount = {}));
var CompanyOnboardingAccountType;
(function (CompanyOnboardingAccountType) {
    CompanyOnboardingAccountType[CompanyOnboardingAccountType["NonDilutiveFunding"] = 0] = "NonDilutiveFunding";
    CompanyOnboardingAccountType[CompanyOnboardingAccountType["CompanyAnalytics"] = 1] = "CompanyAnalytics";
})(CompanyOnboardingAccountType = exports.CompanyOnboardingAccountType || (exports.CompanyOnboardingAccountType = {}));
var CompanyExistingDebt;
(function (CompanyExistingDebt) {
    CompanyExistingDebt["None"] = "none";
    CompanyExistingDebt["Between0And3M"] = "between_0_and_3_m";
    CompanyExistingDebt["Between3And5M"] = "between_3_and_5_m";
    CompanyExistingDebt["Between5And10M"] = "between_5_and_10_m";
    CompanyExistingDebt["Between10And25M"] = "between_10_and_25_m";
    CompanyExistingDebt["Between25And50M"] = "between_25_and_50_m";
    CompanyExistingDebt["MoreThan50M"] = "more_than_50_m";
})(CompanyExistingDebt = exports.CompanyExistingDebt || (exports.CompanyExistingDebt = {}));
var CompanyTargetDebtRaise;
(function (CompanyTargetDebtRaise) {
    CompanyTargetDebtRaise["Between0And3M"] = "between_0_and_3_m";
    CompanyTargetDebtRaise["Between3And5M"] = "between_3_and_5_m";
    CompanyTargetDebtRaise["Between5And10M"] = "between_5_and_10_m";
    CompanyTargetDebtRaise["Between10And25M"] = "between_10_and_25_m";
    CompanyTargetDebtRaise["Between25And50M"] = "between_25_and_50_m";
    CompanyTargetDebtRaise["Between50And100M"] = "between_50_and_100_m";
    CompanyTargetDebtRaise["MoreThan100M"] = "more_than_100_m";
})(CompanyTargetDebtRaise = exports.CompanyTargetDebtRaise || (exports.CompanyTargetDebtRaise = {}));
var CompanyEquityRaised;
(function (CompanyEquityRaised) {
    CompanyEquityRaised["Bootstrapped"] = "bootstrapped";
    CompanyEquityRaised["Between0And5M"] = "between_0_and_5_m";
    CompanyEquityRaised["Between5And15M"] = "between_5_and_15_m";
    CompanyEquityRaised["Between15And25M"] = "between_15_and_25_m";
    CompanyEquityRaised["Between25And50M"] = "between_25_and_50_m";
    CompanyEquityRaised["Between50And100M"] = "between_50_and_100_m";
    CompanyEquityRaised["MoreThan100M"] = "more_than_100_m";
})(CompanyEquityRaised = exports.CompanyEquityRaised || (exports.CompanyEquityRaised = {}));
var PeriodType;
(function (PeriodType) {
    PeriodType["TTM"] = "TTM";
    PeriodType["Q"] = "Q";
})(PeriodType = exports.PeriodType || (exports.PeriodType = {}));
var FinancialDocumentTaskStates;
(function (FinancialDocumentTaskStates) {
    FinancialDocumentTaskStates["Success"] = "SUCCESS";
    FinancialDocumentTaskStates["Pending"] = "PENDING";
    FinancialDocumentTaskStates["Failure"] = "FAILURE";
    FinancialDocumentTaskStates["Progress"] = "PROGRESS";
})(FinancialDocumentTaskStates = exports.FinancialDocumentTaskStates || (exports.FinancialDocumentTaskStates = {}));
/*
 * Glossary
 * Modifiers:
 *  sms: simple moving sum (eg. sms4 means simple moving sum across 4 quarters, so 1 year)
 *  ret: return (eg. ret4 means return over 4 year or YoY while ret1 means return over 1 quarter, so QoQ)
 *  div: divide; often used in metrics that are ratios
 *
 * Modifiers can be combined to then represent a single, compound metric. For instance,
 * revenueOperatingSms4Ret4 means "This year's (sms4) Operating Revenue over (implied) last year's (ret4) Operating Revenue"
 */
var BenchmarkingVariables;
(function (BenchmarkingVariables) {
    // TTM
    BenchmarkingVariables["ebitdaAdjPreMarketingSms4"] = "Pre-marketing<br>EBITDA (TTM)";
    BenchmarkingVariables["ebitdaAdjPreMarketingSms4DivRevenueOperatingSms4"] = "Pre-marketing<br>EBITDA (TTM)";
    BenchmarkingVariables["ebitdaAdjPreMarketingSms4DivRevenueOperatingSms4Ret4"] = "Pre-marketing<br>EBITDA (TTM)";
    BenchmarkingVariables["ebitdaAdjPreMarketingSms4Ret4"] = "Pre-marketing<br>EBITDA % (TTM)";
    BenchmarkingVariables["ebitdaAdjSms4"] = "EBITDA<br>(TTM)";
    BenchmarkingVariables["ebitdaAdjSms4DivRevenueOperatingSms4"] = "";
    BenchmarkingVariables["ebitdaAdjSms4DivRevenueOperatingSms4Ret4"] = "";
    BenchmarkingVariables["ebitdaAdjSms4Ret4"] = "EBITDA %<br>(TTM)";
    BenchmarkingVariables["grossProfitAdjSms4DivRevenueOperatingSms4"] = "Gross Margin";
    BenchmarkingVariables["grossProfitAdjSms4DivRevenueOperatingSms4Ret4"] = "Gross Margin %";
    BenchmarkingVariables["revenueOperatingSms4"] = "Revenue<br>(TTM)";
    BenchmarkingVariables["revenueOperatingSms4Ret4"] = "Revenue %<br>(TTM)";
    BenchmarkingVariables["salesMarketingSms4DivRevenueOperatingSms4"] = "S&M";
    BenchmarkingVariables["salesMarketingSms4DivRevenueOperatingSms4Ret4"] = "S&M %";
    BenchmarkingVariables["workingCapitalSma5DivRevenueOperatingSms4"] = "";
    // Q
    BenchmarkingVariables["ebitdaAdjPreMarketingSms1"] = "Pre-marketing<br>EBITDA (Q)";
    BenchmarkingVariables["ebitdaAdjPreMarketingSms1DivRevenueOperatingSms1"] = "";
    BenchmarkingVariables["ebitdaAdjPreMarketingSms1DivRevenueOperatingSms1Ret1"] = "";
    BenchmarkingVariables["ebitdaAdjPreMarketingSms1DivRevenueOperatingSms1Ret4"] = "";
    BenchmarkingVariables["ebitdaAdjPreMarketingSms1Ret4"] = "";
    BenchmarkingVariables["ebitdaAdjSms1"] = "EBITDA<br>(Q)";
    BenchmarkingVariables["ebitdaAdjSms1DivRevenueOperatingSms1"] = "";
    BenchmarkingVariables["ebitdaAdjSms1DivRevenueOperatingSms1Ret1"] = "";
    BenchmarkingVariables["ebitdaAdjSms1DivRevenueOperatingSms1Ret4"] = "";
    BenchmarkingVariables["ebitdaAdjSms1Ret4"] = "";
    BenchmarkingVariables["grossProfitAdjSms1DivRevenueOperatingSms1"] = "";
    BenchmarkingVariables["grossProfitAdjSms1DivRevenueOperatingSms1Ret1"] = "";
    BenchmarkingVariables["grossProfitAdjSms1DivRevenueOperatingSms1Ret4"] = "";
    BenchmarkingVariables["revenueOperatingSms1"] = "Revenue<br>(Q)";
    BenchmarkingVariables["revenueOperatingSms1Ret1"] = "";
    BenchmarkingVariables["revenueOperatingSms1Ret4"] = "";
    BenchmarkingVariables["salesMarketingSms1DivRevenueOperatingSms1"] = "";
    BenchmarkingVariables["salesMarketingSms1DivRevenueOperatingSms1Ret4"] = "";
    BenchmarkingVariables["workingCapitalSma2DivRevenueOperatingSms1"] = "";
    // Other
    BenchmarkingVariables["assetsCurrentCashAndInvestments"] = "Cash";
    BenchmarkingVariables["assetsCurrentCashAndInvestmentsRet4"] = "Cash %";
    BenchmarkingVariables["assetsCurrentInvty"] = "Inventory";
    BenchmarkingVariables["assetsCurrentInvtyRet4"] = "Inventory %";
    BenchmarkingVariables["assetsCurrentRcv"] = "Receivables";
    BenchmarkingVariables["assetsCurrentRcvRet4"] = "Receivables %";
    BenchmarkingVariables["assetsNonCurrentNetPropPlantEquipment"] = "PP&E";
    BenchmarkingVariables["assetsNonCurrentNetPropPlantEquipmentRet4"] = "PP&E %";
    BenchmarkingVariables["cashRunway1Q"] = "";
    BenchmarkingVariables["cashRunway4Q"] = "";
    BenchmarkingVariables["debtToTotalCapitalRatio"] = "";
    BenchmarkingVariables["debtTotal"] = "Total Debt";
    BenchmarkingVariables["debtTotalRet4"] = "";
    BenchmarkingVariables["equityPaidInCapital"] = "Equity Capital";
    BenchmarkingVariables["equityPaidInCapitalRet4"] = "";
    BenchmarkingVariables["liabilitiesCurrentAccountPayable"] = "";
    BenchmarkingVariables["liabilitiesCurrentAccountPayableRet4"] = "";
    BenchmarkingVariables["magicNumber"] = "";
    BenchmarkingVariables["workingCapital"] = "";
})(BenchmarkingVariables = exports.BenchmarkingVariables || (exports.BenchmarkingVariables = {}));
exports.SENSITIVE_COUNTRIES = [
    'AF',
    'BY',
    'BA',
    'AL',
    'XK',
    'BG',
    'CD',
    'CF',
    'CN',
    'CU',
    'ET',
    'HK',
    'HR',
    'IR',
    'IQ',
    'LB',
    'LY',
    'ML',
    'MM',
    'MK',
    'ME',
    'NI',
    'KP',
    'RU',
    'RO',
    'RS',
    'SI',
    'SO',
    'SD',
    'SY',
    'VE',
    'YE',
    'ZW', // Zimbabwe
];
//# sourceMappingURL=enums.js.map